import { graphql } from '@generated/gql';

export const GOAL_LINKING_FETCH_GOAL_NAME = graphql(/** GraphQL */ `
  query goalLinkingFetchGoalName($goalId: ObjectID!) {
    fetchGoal(goalId: $goalId) {
      goal {
        id
        name
      }
    }
  }
`);
